/**
 * OrderForm - Main order form component
 *
 * CRITICAL: 절대 목업 데이터 사용 금지!
 * - 실제 운영 API 주문만 실행
 * - 주문 실패 시: "주문 실패: {상세 메시지}" 표시
 * - 시장 휴장 시: 명확한 안내 메시지
 */
import React from 'react';
import { OrderFormProps } from './types';
import { useOrderForm } from './useOrderForm';
import OrderFormFields from './OrderFormFields';
import OrderFormActions from './OrderFormActions';
import './OrderForm.css';

const OrderForm: React.FC<OrderFormProps> = ({ onOrderSuccess }) => {
  const {
    // Form state
    symbol,
    setSymbol,
    quantity,
    setQuantity,
    side,
    setSide,
    loading,
    error,
    showToast,
    toastMessage,
    toastType,
    // Position state
    positions,
    positionsLoading,
    selectedPosition,
    accountCash,
    // Price state
    currentPrice,
    priceLoading,
    estimatedAmount,
    // Functions
    handleSelectPosition,
    getValidationError,
    isOrderValid,
    handleSubmit,
  } = useOrderForm(onOrderSuccess);

  return (
    <div className="order-form-container">
      <h3>주문</h3>

      {/* Toast Notification */}
      {showToast && (
        <div className={`order-toast ${toastType}`}>
          {toastMessage}
        </div>
      )}

      <form className="order-form" onSubmit={handleSubmit}>
        <OrderFormFields
          side={side}
          symbol={symbol}
          quantity={quantity}
          loading={loading}
          positions={positions}
          positionsLoading={positionsLoading}
          selectedPosition={selectedPosition}
          currentPrice={currentPrice}
          priceLoading={priceLoading}
          onSideChange={setSide}
          onSymbolChange={setSymbol}
          onQuantityChange={setQuantity}
          onSelectPosition={handleSelectPosition}
        />

        <OrderFormActions
          side={side}
          loading={loading}
          error={error}
          estimatedAmount={estimatedAmount}
          accountCash={accountCash}
          validationError={getValidationError()}
          isOrderValid={isOrderValid()}
        />
      </form>
    </div>
  );
};

export default OrderForm;
